function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import PropTypes from 'prop-types';
import React from 'react';
import ResourceCard from '../../resource-card/ResourceCard';

var RelatedResources = function RelatedResources(_ref) {
  var resources = _ref.resources,
      title = _ref.title,
      isLazyLoaded = _ref.isLazyLoaded,
      mzData = _ref.mzData,
      cardsPerRow = _ref.cardsPerRow,
      cardSize = _ref.cardSize;
  if (!resources.length) return null;
  var relatedCards = resources.map(function (resource) {
    return /*#__PURE__*/React.createElement(ResourceCard, _extends({
      key: resource.id
    }, resource, {
      cardsPerRow: cardsPerRow,
      cardSize: cardSize,
      isLazyLoaded: isLazyLoaded,
      mzData: mzData
    }));
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "heading heading--medium text-center margin-bottom-ml col-md-12"
  }, title), relatedCards);
};

RelatedResources.displayName = "RelatedResources";
RelatedResources.propTypes = {
  title: PropTypes.string.isRequired,
  resources: PropTypes.arrayOf(PropTypes.object).isRequired,
  isLazyLoaded: PropTypes.bool,
  mzData: PropTypes.object,
  cardsPerRow: PropTypes.number,
  cardSize: PropTypes.string
};
RelatedResources.defaultProps = {
  cardsPerRow: 4,
  cardSize: 'sm',
  isLazyLoaded: false,
  mzData: {}
};
export default RelatedResources;